import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { contact } from "@/data/site";
import { Eyebrow, Reveal } from "../site/motion";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative overflow-hidden bg-navy py-24 md:py-32"
    >
      <div className="bg-grid-dark absolute inset-0" aria-hidden="true" />
      <div className="absolute -left-40 top-[-120px] h-[440px] w-[440px] rounded-full bg-blue-600/25 blur-[130px]" aria-hidden="true" />
      <div className="absolute -right-40 bottom-[-160px] h-[440px] w-[440px] rounded-full bg-violet-600/25 blur-[130px]" aria-hidden="true" />

      <div className="relative mx-auto max-w-[860px] px-6 text-center md:px-8">
        <Reveal className="flex justify-center">
          <Eyebrow dark>Let&rsquo;s build</Eyebrow>
        </Reveal>
        <Reveal delay={1}>
          <h2
            data-testid="contact-heading"
            className="mt-6 text-4xl font-extrabold leading-[1.04] tracking-[-0.03em] text-white sm:text-5xl lg:text-6xl"
          >
            Have an idea{" "}
            <span className="bg-gradient-to-r from-blue-400 to-violet-400 bg-clip-text text-transparent">
              worth building?
            </span>
          </h2>
        </Reveal>
        <Reveal delay={2}>
          <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-slate-400 md:text-base">
            Tell us what you&rsquo;re working on. We&rsquo;ll help you explore the right
            technology approach for your product, platform, or business.
          </p>
        </Reveal>
        <Reveal delay={3} className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-start-project-button"
            className="group inline-flex items-center gap-2.5 rounded-[10px] bg-white px-7 py-3.5 text-sm font-semibold text-navy transition-colors duration-300 hover:bg-blue-600 hover:text-white"
          >
            Start a Project
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a
            href={contact.phoneHref}
            data-testid="cta-call-button"
            className="group inline-flex items-center gap-2.5 rounded-[10px] border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-[border-color,background-color] duration-300 hover:border-white/50 hover:bg-white/5"
          >
            <Phone size={15} className="text-slate-400 transition-colors duration-300 group-hover:text-white" />
            {contact.phone}
          </a>
        </Reveal>
        <Reveal delay={4}>
          <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.24em] text-slate-500" data-testid="contact-meta">
            {contact.email} — {contact.location}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
